import _ from 'lodash';
//navigationDelegate必須
export function SplitResponsiveManager() {
  // eslint-disable-next-line no-unused-vars
  var navigationDelegate;
}

SplitResponsiveManager.prototype = {
  init() {
    // eslint-disable-next-line no-unused-vars
    var _this = this;
  },

  setDelegate(delegate) {
    var _this = this;
    delegate.observeNavi(function(e, status) {
      _this.update(status);
    });
  },

  update(status) {
    var rtype = ['split-HD', 'split-PC', 'split-TB', 'split-SP'];
    var splitResponsive = function(val) {
      if (val >= 1280) {
        return 'split-HD';
      } else if (val >= 1024) {
        return 'split-PC';
      } else {
        // CSS含めてスマホコードはやりかけで放置されているのでsplit-SPは削除して、画面幅がPC未満になった場合はタブレットのデザインを優先する
        return 'split-TB';
      }
    };

    var splitview = {
      splitview1: document.querySelector('#func-navi--item1+.rail__main'),
      splitview2: document.querySelector('#func-navi--item2+.rail__main'),
      slideview1: document.querySelector('.sys-splitview-1 .slide-view'),
      slideview2: document.querySelector('.sys-splitview-2 .slide-view'),
    };

    var responsive = function() {};
    responsive.prototype = {
      isTablet() {
        return navigator.userAgent.indexOf('iPad') > -1;
      },
      type() {
        var val = window.innerWidth;
        if (val >= 1280) {
          return 'HD';
        } else if (val > 1024) {
          return 'PC';
        } else if (val === 1024 && !this.isTablet()) {
          // 1024pxのPCモニタの場合に、`menuWidth`で`0`を返したいため「PC」とは別文字列を返します
          // 関連課題 BLDE_V2-3124
          return 'PC_1024';
        } else {
          // CSS含めてスマホコードはやりかけで放置されているのでSPは削除して、画面幅がPC未満になった場合はタブレットのデザインを優先する
          return 'TB';
        }
      },
      menuWidth() {
        const type = this.type();
        if (type === 'PC' || type === 'HD') {
          return -210;
        }
        return 0;
      },
    };

    var decorater = function() {
      // eslint-disable-next-line no-unused-vars
      var width;
      this.resp = new responsive();
    };
    decorater.prototype = {
      masternavi() {
        this.width = window.innerWidth;
        this.width += status.masternavi ? this.resp.menuWidth() : 0;
        this.width =
          status.splitview1 && status.splitview2 ? this.width / 2 : this.width;
        return this;
      },
      splitview1() {
        this.width += status.funcnavi1 ? this.resp.menuWidth() : 0;
        return this;
      },
      splitview2() {
        this.width += status.funcnavi2 ? this.resp.menuWidth() : 0;
        return this;
      },
      slideview1() {
        return this;
      },
      slideview2() {
        return this;
      },
    };

    var dec = new decorater();

    _.each(splitview, function(view, key) {
      if (view) {
        _.each(rtype, function(classname) {
          view.classList.remove(classname);
        });
        var w = dec.masternavi()[key]().width;
        view.classList.add(splitResponsive(w));
        //rail__mainのoverflow=autoを除外
        if (view.querySelector('.fieldstree-main')) {
          view.style.overflow = 'visible';
          view.style.overflowX = 'visible';
        }
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/utilities/splitManager.js